// eslint-disable-next-line import/no-cycle
import {
  Property,
} from '@/types';

// eslint-disable-next-line import/no-cycle
import {
  getTemplateIframeDocument,
} from '../utils/helpers';

// eslint-disable-next-line import/no-cycle
import { sanitizeTranslationMarkup, setTranslationInState } from '../utils/translate';

/**
 * Set text content while preserving child elements (like icons)
 */
const setText = (selector: string, property: Property) => {
  const template = getTemplateIframeDocument();
  const element: HTMLElement|null = template?.querySelector(selector);
  if (element && undefined !== property.value) {
    const sanitized = sanitizeTranslationMarkup(element);

    // Save all child elements (like icons)
    const childElements = Array.from(sanitized.children);

    // Update text content
    sanitized.innerHTML = property.value;

    // Re-append saved child elements
    childElements.forEach((child) => {
      sanitized.appendChild(child);
    });

    setTranslationInState(element, 'markup', '', true);
  }
};

export default setText;
